export const sumVisibleFinancials = (items = []) => items.reduce((totals, item) => ({
  purchases: totals.purchases + (Number(item.totalPurchase) || 0),
  payments: totals.payments + (Number(item.totalPayment) || 0),
  balance: totals.balance + (Number(item.totalBalance) || 0),
}), { purchases: 0, payments: 0, balance: 0 });
